export default {"src":"/_next/static/media/adidas.a0e2d341.svg","height":51,"width":76,"blurWidth":0,"blurHeight":0};